@if (booking) {
<app-card>
  @if (!booking.IsOneWay) {
  @if (appSettings.appType === 'app') {
  @if (booking?.Status != status.Canceled && booking?.Status < status.Returned) {
  <button class="w-100" (click)="openBooking(); $event.stopPropagation()">
    <mat-icon>launch</mat-icon>
    <span>{{ 'Intellitrailer.MyPage.BookingOverview.lblOpen' | translate }}</span>
  </button>
  <div class="row">
    <div class="col text-end">
      <mat-icon (click)="openTrailerInfo(); $event.stopPropagation()">info</mat-icon>
    </div>
  </div>
  }
  @if (booking.PrimaryType?.PictureUri) {
  <img src="{{ booking.PrimaryType.PictureUri }}" />
  }
  @if (booking.Status == 100 || booking.Status == 150) {
  <div class="row">
    <small class="col-5">{{ 'Intellitrailer.MyPage.BookingOverview.lblReturnTo' | translate }}</small>
    <small class="col-7"><strong>{{ booking.PickupLocation.Name }}</strong></small>

    <small class="col-5">{{ 'Intellitrailer.MyPage.BookingOverview.lblTime' | translate }}</small>
    <small class="col-7">{{ booking.ReturnTime | date: 'yyyy-MM-dd HH:mm' | transliterate }}</small>

    @if (booking.Status == 100) {
    <small class="col-5">{{ 'Intellitrailer.MyPage.BookingOverview.lblTimeLeft' | translate }}</small>
    } @else {
    <small class="col-5 red">{{ 'Intellitrailer.MyPage.BookingOverview.lblDelay' | translate }}</small>
    }

    <small class="col-7" [ngClass]="{ red: booking.Status == 150 }">
      {{ countdown?.locale(Settings.clientSettings.Language).humanize() }}
    </small>

    <small class="col-5">{{ 'Intellitrailer.MyPage.BookingOverview.lblBooking' | translate }}</small>
    <small class="col-7">{{ booking.Id }}</small>
  </div>
  }
  @else {
  <div class="row">
    @if (booking?.PickupLocation?.Name) {
    <small class="col-5">{{ 'Intellitrailer.MyPage.BookingOverview.lblPlace' | translate }}</small>
    <small class="col-7"><strong>{{ booking.PickupLocation.Name }}</strong></small>
    }
    @if (booking?.PickupTime) {
    <small class="col-5">{{ 'Intellitrailer.MyPage.BookingOverview.lblStartTime' | translate }}</small>
    <small class="col-7">{{ booking.PickupTime | date: 'yyyy-MM-dd HH:mm' | transliterate }}</small>
    }
    @if (booking?.ReturnTime) {
    <small class="col-5">{{ 'Intellitrailer.MyPage.BookingOverview.lblEndTime' | translate }}</small>
    <small class="col-7">{{ booking.ReturnTime | date: 'yyyy-MM-dd HH:mm' | transliterate }}</small>
    }
    @if (booking?.Id) {
    <small class="col-5">{{ 'Intellitrailer.MyPage.BookingOverview.lblBooking' | translate }}</small>
    <small class="col-7">{{ booking.Id | transliterate }}</small>
    }
  </div>
  }
  } @else {
  @if (booking.PrimaryType?.PictureUri) {
  <img src="{{ booking.PrimaryType.PictureUri }}" />
  }
  @if (booking.Status == 100 || booking.Status == 150) {
  <div class="row">
    <small class="col col-5">{{'Intellitrailer.MyPage.BookingOverview.lblReturnTo' | translate : 'Return to' }}</small>
    <small class="col col-7"><strong>{{ booking.PickupLocation.Name }}</strong></small>

    <small class="col col-5">{{'Intellitrailer.MyPage.BookingOverview.lblTime' | translate : 'Time' }}</small>
    <small class="col col-7">{{ booking.ReturnTime | date: 'yyyy-MM-dd HH:mm' | transliterate }}</small>

    @if (booking.Status == 100) {
    <small class="col col-5">{{'Intellitrailer.MyPage.BookingOverview.lblTimeLeft' | translate : 'Time left' }}</small>
    }
    @if (booking.Status == 150){
    <small class="col col-5 red">{{'Intellitrailer.MyPage.BookingOverview.lblDelay' | translate : 'Delayed' }}</small>
    }

    <small class="col col-7" [ngClass]="{ red: booking.Status == 150 }">
      {{ countdown?.locale(Settings.clientSettings.Language).humanize() | transliterate }}
    </small>

    <small class="col col-5">{{'Intellitrailer.MyPage.BookingOverview.lblBooking' | translate : 'Booking' }}</small>
    <small class="col col-7">{{ booking.Id | transliterate }}</small>
  </div>
  } @else {
  <div class="row">
    @if (booking?.PickupLocation?.Name) {
    <small class="col col-5">{{'Intellitrailer.MyPage.BookingOverview.lblPlace' | translate : 'Place' }}</small>
    <small class="col col-7"><strong>{{ booking.PickupLocation.Name }}</strong></small>
    }
    @if (booking?.PickupTime) {
    <small class="col col-5">{{'Intellitrailer.MyPage.BookingOverview.lblStartTime' | translate : 'Start time' }}</small>
    <small class="col col-7">{{ booking.PickupTime | date: 'yyyy-MM-dd HH:mm' | transliterate }}</small>
    }
    @if (booking?.ReturnTime) {
    <small class="col col-5">{{'Intellitrailer.MyPage.BookingOverview.lblEndTime' | translate : 'End time' }}</small>
    <small class="col col-7">{{ booking.ReturnTime | date: 'yyyy-MM-dd HH:mm' | transliterate }}</small>
    }
    @if (booking?.Id) {
    <small class="col col-5">{{'Intellitrailer.MyPage.BookingOverview.lblBooking' | translate : 'Booking' }}</small>
    <small class="col col-7">{{ booking.Id | transliterate }}</small>
    }
  </div>
  }
  }
  }
  @else if(booking.IsOneWay)
  {
  <button class="w-100" (click)="openBooking(); $event.stopPropagation()">
    <mat-icon>launch</mat-icon>
    <span>{{ 'Intellitrailer.MyPage.BookingOverview.lblOpen' | translate }}</span>
  </button>
  <div class="row">
    <div class="col col-12" style="text-align: center"><strong>{{booking.Id | transliterate}}</strong></div>
    <div class="col-12 image-container image-container-overview" style="min-height: 100px; padding: 15px;">
      @if (booking.PrimaryType?.PictureUri) {
      <div class="item-image" style="background-image: url({{ booking.PrimaryType.PictureUri }});"></div>
      }
    </div>

    <div class="col-12 text-container-overview" style="text-align: center">

      @if (booking.Status == 100 || booking.Status == 150) {
      <div>
        <div class="title-with-divider">
          <div class="title">{{'Intellitrailer.MyPage.BookingOverview.lblPickup' | translate : 'Pickup' }}</div>
        </div>
        <div class="row">
          <div class="col">
            @if (booking?.PickupLocation?.Name) {
            <strong>{{booking.PickupLocation.Name}}<br /> </strong>
            }
            @if (booking?.PickupLocation?.Address) {
            <span>{{ booking.PickupLocation.Address }} <br /></span>
            }
            {{booking.PickupTime | date : 'yyyy-MM-dd HH:mm' | transliterate }}
          </div>
        </div>
        <div class="title-with-divider">
          <div class="title">{{'Intellitrailer.MyPage.BookingOverview.lblReturn' | translate : 'Return' }}</div>
        </div>
        <div class="row">
          <div class="col">
            @if (booking?.ReturnLocation?.Name) {
            <strong>{{booking.ReturnLocation.Name}}<br /></strong>
            }
            @if (booking?.ReturnLocation?.Address) {
            <span>{{ booking.ReturnLocation.Address }} <br /></span>
            }
            {{booking.ReturnTime | date : 'yyyy-MM-dd HH:mm' | transliterate }}
          </div>
        </div>
        <div class="title-with-divider">
          <div class="title">{{'Intellitrailer.MyPage.BookingOverview.lblStatus' | translate : 'Status' }}</div>
        </div>

        <div class="row">
          <div class="col-12">
            @if (booking?.Status == 100) {
            <strong>{{'Intellitrailer.MyPage.BookingOverview.valStatus100' | translate : 'Active' }}</strong>
            }
            @if (booking?.Status == 150) {
            <strong>{{'Intellitrailer.MyPage.BookingOverview.valStatus150' | translate : 'Delayed' }}</strong>
            }
          </div>
          @if (booking?.Status == 100) {
          <div class="col-12">
            {{'Intellitrailer.MyPage.BookingOverview.lblTimeLeft' | translate : 'Time left' }}: {{ countdown?.locale(Settings.clientSettings.Language).humanize() | transliterate }}
          </div>
          }
          @if (booking?.Status == 150) {
          <div class="col-12">
            {{'Intellitrailer.MyPage.BookingOverview.lblLate' | translate : 'Late' }}: {{ countdown?.locale(Settings.clientSettings.Language).humanize() | transliterate }}
          </div>
          }
        </div>

        <!--
          <div class="col col-5">{{'Intellitrailer.MyPage.BookingOverview.lblReturnTo' | translate : 'Return to' }}</div>
          <div class="col col-7"><strong>{{booking.PickupLocation.Name}}</strong></div>
          <div class="col col-5">{{'Intellitrailer.MyPage.BookingOverview.lblTime' | translate : 'Time' }}</div>
          <div class="col col-7">{{booking.ReturnTime | date : 'yyyy-MM-dd HH:mm' | transliterate}}</div>
          <div class="col col-5" *ngIf="booking.Status == 100">{{'Intellitrailer.MyPage.BookingOverview.lblTimeLeft' | translate : 'Time left' }}</div>
          <div class="col col-5" *ngIf="booking.Status == 150" [ngClass]="{ red: booking.Status == 150 }">{{'Intellitrailer.MyPage.BookingOverview.lblDelay' | translate : 'Delayed' }}</div>
          <div class="col col-7" [ngClass]="{ red: booking.Status == 150 }">
            {{ countdown?.locale(Settings.clientSettings.Language).humanize() | transliterate }}
          </div>
          <div class="col col-5">{{'Intellitrailer.MyPage.BookingOverview.lblBooking' | translate : 'Booking' }}</div>
          <div class="col col-7">{{booking.Id | transliterate}}</div>
        -->
      </div>
      }

      <ng-container *ngIf="booking?.Status != 100 && booking?.Status != 150">
        <div class="title-with-divider">
          <div class="title">{{'Intellitrailer.MyPage.BookingOverview.lblPickup' | translate : 'Pickup' }}</div>
        </div>
        <div class="row">
          <div class="col">
            <strong *ngIf="booking?.PickupLocation?.Name">{{booking.PickupLocation.Name}}<br /></strong>
            {{booking.PickupTime | date : 'yyyy-MM-dd HH:mm'}}
          </div>
        </div>
        <div class="title-with-divider">
          <div class="title">{{'Intellitrailer.MyPage.BookingOverview.lblReturn' | translate : 'Return' }}</div>
        </div>
        <div class="row">
          <div class="col">
            <strong *ngIf="booking?.ReturnLocation?.Name">{{booking.ReturnLocation.Name}}<br /></strong>
            {{booking.ReturnTime | date : 'yyyy-MM-dd HH:mm'}}
          </div>
        </div>
        <div class="title-with-divider">
          <div class="title">{{'Intellitrailer.MyPage.BookingOverview.lblStatus' | translate : 'Status' }}</div>
        </div>
        <div class="row">
          <div class="col-12">
            <strong *ngIf="booking?.Status == 0">{{'Intellitrailer.MyPage.BookingOverview.valStatus0' | translate : 'Preliminary' }}</strong>
            <strong *ngIf="booking?.Status == 50">{{'Intellitrailer.MyPage.BookingOverview.valStatus50' | translate : 'Confirmed' }}</strong>
          </div>
          <ng-container *ngIf="booking?.Status == 50 && onewayStatus == 0">
            <div class="col-12">
              {{'Intellitrailer.MyPage.BookingOverview.lblConfirmationDate' | translate : 'Confirmation date' }}<br />
              {{booking.BoundAt | date : 'yyyy-MM-dd'}}
            </div>
            <ng-container *ngIf="onewayIsTrailerOnStation">
              <div class="col-12">
                {{'Intellitrailer.MyPage.BookingOverview.lblTrailerOnStation' | translate : 'Trailer is waiting at the station' }}
              </div>
            </ng-container>
            <ng-container *ngIf="!onewayIsTrailerOnStation">
              <div class="col-12">
                {{'Intellitrailer.MyPage.BookingOverview.lblTrailerIncomming' | translate : 'The trailer is on its way to the station' }}
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="booking?.Status == 0 && onewayStatus == 0">
            <div class="col-12">
              {{'Intellitrailer.MyPage.BookingOverview.lblEstimatedConfirmationDate' | translate : 'Estimated confirmation date' }}<br />
              {{bookingQueue?.BindsAt | date : 'yyyy-MM-dd'}}
            </div>
          </ng-container>
          <ng-container *ngIf="booking?.Status == 0 && onewayStatus == 2"> 
            <div class="col">{{'Intellitrailer.MyPage.BookingOverview.lblOneWayNoTrailerEstimated' | translate: 'We are actively looking for a trailer for you and hope to find a solution as soon as possible.'}} {{confirmationAmbitionDate | date : 'yyyy-MM-dd'}}</div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
  }
  @if (booking?.Status != status.Canceled && booking?.Status < status.Returned) {
  <div class="row p-0">
    @if(!booking.IsOneWay){
    <div class="col-6 p-0 justify-content-center">
      <div class="w-100" (click)="change();$event.stopPropagation()">
        <button class="w-100 change-booking-action" [disabled]="!canChangeBooking" [style.pointer-events]="!canChangeBooking ? 'none' : 'auto'">
          <mat-icon>edit</mat-icon>
          <span>{{ 'Intellitrailer.MyPage.BookingOverview.ChangeBookingLabel' | translate : 'Change' }}</span>
        </button>
      </div>
    </div>
    <div class="col-6 p-0 justify-content-center">
      <div class="w-100" (click)="cancel(); $event.stopPropagation()">
        <button class="w-100 change-booking-action" [disabled]="!canChangeBooking" [style.pointer-events]="!canChangeBooking ? 'none' : 'auto'">
          <mat-icon>cancel</mat-icon>
          <span>{{ 'Intellitrailer.MyPage.BookingOverview.CancelBookingLabel' | translate  : 'Cancel'}}</span>
        </button>
        </div>
      </div>
      }
      @else{
    <div class="col p-0 justify-content-center">
      <div class="w-100" (click)="cancel(); $event.stopPropagation()">
        <button class="w-100 change-booking-action" [disabled]="!canChangeBooking" [style.pointer-events]="!canChangeBooking ? 'none' : 'auto'">
          <mat-icon>cancel</mat-icon>
          <span>{{ 'Intellitrailer.MyPage.BookingOverview.CancelBookingLabel' | translate  : 'Cancel'}}</span>
        </button>
      </div>
    </div>
      }
    </div>
  } @else {
  <button [matMenuTriggerFor]="menu" class="button-center" (click)="$event.stopPropagation()">
    <mat-icon>expand_more</mat-icon>
    <span>{{ 'Intellitrailer.MyPage.BookingOverview.lblMore' | translate : '' }}</span>
  </button>
  }

  <mat-menu #menu="matMenu" class="bookingOverview" (click)="$event.stopPropagation()">
    @if ((booking?.Status == status.Reserved || booking?.Status == status.ReservedAndBound) && !booking.IsOneWay) {
    <div (click)="change()" style="display: flex; width: 100%;">
      <button mat-menu-item class="change-booking-action w-100" [disabled]="!canChangeBooking" (click)="$event.stopPropagation()">
        <mat-icon>edit</mat-icon>
        <span>{{ 'Intellitrailer.MyPage.BookingOverview.ChangeBooking' | translate : 'Change Booking' }}</span>
      </button>
    </div>
    <div (click)="cancel()" style="display: flex; width: 100%;">
      <button mat-menu-item class="change-booking-action w-100" [disabled]="!canChangeBooking" (click)="$event.stopPropagation()">
        <mat-icon>cancel</mat-icon>
        <span>{{ 'Intellitrailer.MyPage.BookingOverview.CancelBooking' | translate : 'Cancel Booking' }}</span>
      </button>
    </div>
      }
      <button mat-menu-item (click)="sendEmail(); $event.stopPropagation()">
        <mat-icon>receipt</mat-icon>
        {{ 'Intellitrailer.MyPage.BookingOverview.SendReceipt' | translate }}
      </button>
      <button mat-menu-item (click)="openTrailerInfo(); $event.stopPropagation()">
        <mat-icon>info</mat-icon>
        {{ 'Intellitrailer.MyPage.BookingOverview.TrailerInfo' | translate }}
      </button>
  </mat-menu>
</app-card>
}



